if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      
      this.cart = document.querySelector('cart-drawer');
      this.caartPage = document.querySelector('cart-page');

      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
    }

    connectedCallback() {
      //this.changeSubscribtionunput();
    }

    onSubmitHandler(evt, classAInstance) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
      this.handleErrorMessage();
      
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('free')
      this.submitButton.classList.add('loading');
      
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      const formData = new FormData(this.form);
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

     
      
      // add subscription products
      this.addSubscriptionProducts(formData);
      
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else if (!this.cart) {
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {

            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
            
          } else {
            if( window.location.pathname != '/cart'){
              this.cart.renderContents(response);
            }
            
           
          }
          //
          getDataCart();
          
          //reload cart page
          if (this.caartPage) {
            this.caartPage.updateCartComponent();
          } 
         

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
         
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });

        
    }


    updateCartPageComponent(){
      if (this.caartPage) { 
        fetch('/cart')
        .then(response => response.text()) 
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartPage = doc.querySelector('cart-page'); 
          const currentCartPage = document.querySelector('cart-page'); 

          if (newCartPage) {
            currentCartPage.replaceWith(newCartPage); 
            this.loaderUpdate(false);
            openProtectionPopupInDrawerCart()
          }else{
            document.querySelector('#PageContainer').innerHTML = `
              <div class="page-width">    
                <div class="empty-page tc">
                  <h4>No Products in the Cart</h4>
                  <a href="/collections/order-your-model-now" class="btn">{{ section.settings.empty_cart_button_text }} <i class="at at-angle-right-r" aria-hidden="true"></i></a> </div>
              </div>
            `;
          }
          
        })
        .catch(error => {
          console.error('Error:', error);
        });
      }
    }

    addSubscriptionProducts(formData) {

      const subscriptionInput = this.querySelector('#subscription-product-1');
     
      if (!subscriptionInput) return;

      console.log(subscriptionInput.checked)
      if(subscriptionInput.checked != false){

       

        const productIds = subscriptionInput.value.replace(/\s+/g, '').split(',');
        const sellingPlans = subscriptionInput.dataset.selling_plan.replace(/\s+/g, '').split(',');
      
          

        productIds.forEach((id, index) => {
         
          formData.append('items[][id]', id);
          if (sellingPlans[index]) {
        
            formData.append('items[][selling_plan]', sellingPlans[index]);
          }
        });

        

      }
    }



    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        if (errorMessage.email) {
          this.emailErrorMessage = this.querySelector('.recipient-form__email-error-message-wrapper .product-form__error-message');
          if (!this.emailErrorMessage) return;
          this.emailErrorMessage.parentNode.toggleAttribute('hidden', !errorMessage);
          this.emailErrorMessage.textContent = errorMessage.email;
        } else {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  });
}

